// extracted by mini-css-extract-plugin
export default {"Ribbon":"Ribbon_Ribbon__Cr3EU","Ribbon_Text":"Ribbon_Ribbon_Text__DEWBZ"};